import React from 'react'
import { useSelector } from 'react-redux'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { SkillBiteEditSlice } from '../../../../reducers'
import { Typography, Dialog, DialogTitle, DialogContent, Grid, DialogActions, Button, Box, CircularProgress, useTheme } from '@mui/material'
import { WarningRounded } from '@mui/icons-material'

const SkillBitePublishModal = ({ open, setOpen }) => {
  const { palette } = useTheme()
  const skillBite = useSelector(SkillBiteEditSlice.selectors.selectSkillBite)
  const { id, name } = skillBite
  const [publishSkillBite] = useEvent([SkillBiteEditSlice.eventBus.publishSkillBite({
    onSuccess: () => setOpen(false),
    onError: () => setOpen(false)
  })])

  const handleClose = () => {
    setOpen(false)
  }

  const handlePublish = () => {
    publishSkillBite.trigger({ skillBiteId: id })
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      data-test='skill-bite-publish-modal'
      PaperProps={{
        sx: {
          width: '50%'
        }
      }}
    >
      <DialogTitle
        data-test='skill-bite-publish-modal-title'
        style={{ borderBottom: '1px solid #E0E0E0' }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography
            variant='h6'
            data-test='skill-bite-publish-modal-title'
          >
            Publish Skill Bite
          </Typography>
        </Box>
      </DialogTitle>
      <Grid
        container
        direction='column'
      >
        <DialogContent
          data-test='skill-bite-publish-modal-content'
        >
          {!publishSkillBite.isWorking ? (
            <>
              <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start' sx={{ backgroundColor: '#fcefef', border: '1px solid #f7bdbd', borderRadius: 4, padding: 2 }}>
                <Box>
                  <WarningRounded htmlColor={palette.error.dark} />
                </Box>
                <Box ml={2}>
                  <Typography variant='secondary' color={palette.error.dark} sx={{ fontWeight: 600 }}>
                    {name} Skill Bite publishing
                  </Typography>
                  <Typography>
                    Before you proceed, please be aware that once the Skill Bite is published, its structural elements, such as the arrangement of sessions, cannot be modified.
                  </Typography>
                </Box>
              </Box>
              <Box mt={2}>
                <Typography>
                  The position and order of Sessions, Sections, and Pages are fixed, and they cannot be deleted.
                </Typography>
                <Typography mt={2}>
                  You will, however, retain the ability to edit specific text points.
                </Typography>
                <Typography mt={2}>
                  Published Skill Bites will be accessible to all clients with this feature enabled.
                </Typography>
                <Typography mt={2}>
                  Are you sure you want to proceed with publishing?
                </Typography>
              </Box>
            </>
          ) : (
            <Box display='flex' flexDirection='column' alignItems='center' mb={2} mt={2}>
              <CircularProgress size={48} color='primary' />
              <Typography mt={2}>Publishing {name} Skill Bite, please wait...</Typography>
            </Box>
          )}
        </DialogContent>
      </Grid>
      {!publishSkillBite.isWorking && (
        <DialogActions>
          <Button
            autoFocus
            onClick={handleClose}
            data-test='skill-bite-publish-modal-cancel-button'
          >
            Cancel
          </Button>
          <Button
            autoFocus
            onClick={handlePublish}
            data-test='skill-bite-publish-modal-proceed-button'
          >
            Proceed
          </Button>
        </DialogActions>
      )}
    </Dialog>
  )
}

export default SkillBitePublishModal
